interface SentryFrameLike {
  filename?: string;
  function?: string;
}

interface SentryExceptionLike {
  value?: string;
  stacktrace?: { frames?: SentryFrameLike[] };
}

interface SentryEventLike {
  exception?: { values?: SentryExceptionLike[] };
}

/** Ignore known expected errors that should not be sent to Sentry. */
export function shouldIgnoreSentryEvent(event: SentryEventLike): boolean {
  const exceptions = event.exception?.values ?? [];

  return exceptions.some((exception) => {
    const message = exception.value ?? "";
    // const frames = exception.stacktrace?.frames ?? [];

    const isExpiredSessionError = message === "Invalid or expired session token";

    return isExpiredSessionError;
  });
}
